import * as React from 'react';
const SvgCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.472 3A2.53 2.53 0 0 1 17 5.528v8.944A2.53 2.53 0 0 1 14.472 17H5.528A2.53 2.53 0 0 1 3 14.472V5.528A2.53 2.53 0 0 1 5.528 3zm1.361 4.278H4.167v7.194c0 .752.61 1.361 1.36 1.361h8.945c.752 0 1.361-.61 1.361-1.36zm-4.281 1.318q.778 0 1.234.414.456.415.456 1.12 0 .407-.21.724a1.45 1.45 0 0 1-.569.5q.433.2.667.55.233.35.233.79 0 .73-.493 1.156-.495.428-1.314.428-.825 0-1.32-.43-.495-.429-.496-1.154 0-.444.236-.797t.66-.543a1.44 1.44 0 0 1-.563-.5 1.3 1.3 0 0 1-.207-.723q0-.707.455-1.12.456-.415 1.23-.415m-2.937.057v5.549h-.919v-4.44l-1.356.464v-.779l2.158-.794zm2.933 3.08q-.402 0-.644.25-.24.252-.24.665 0 .407.236.65.238.243.656.243.417 0 .65-.235.235-.236.234-.657 0-.411-.245-.663t-.647-.253m.004-2.396q-.354 0-.559.222-.204.222-.205.606 0 .38.207.604t.56.224.56-.224q.208-.225.208-.604 0-.36-.21-.595a.72.72 0 0 0-.561-.233m2.92-5.17H5.528c-.752 0-1.361.61-1.361 1.36v.584h11.666v-.583c0-.752-.61-1.361-1.36-1.361"
    />
  </svg>
);
export default SvgCalendar;
